/* eslint-disable @angular-eslint/no-outputs-metadata-property */
/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @angular-eslint/no-inputs-metadata-property */
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */

import { ChangeDetectionStrategy, Component, EventEmitter } from '@angular/core';
import { DcrRadioGroup } from '@diekeure/dcr-components';
import { BaseProxyComponent } from '../lib/base.proxy';
import { ProxyWebComponent } from './../lib/utils';

export declare interface DcrRadioGroupComponent extends DcrRadioGroup {
  valueChange: EventEmitter<CustomEvent<string>>;
}

@ProxyWebComponent()
@Component({
  standalone: true,
  selector: `
    dcr-radio-group[formControl],
    dcr-radio-group[formControlName],
    dcr-radio-group[ngModel]
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['name', 'label', 'supportingText', 'required', 'disabled', 'value', 'invalid', 'validationMessage'],
  outputs: ['valueChange'],
})
export class DcrRadioGroupComponent extends BaseProxyComponent {}
